import type { DownloadPremiereMediaDialogRequest } from './downloadPremiereMediaDialogRequest';
import { requestDialog } from './requestDialog';

export function showDownloadPremiereMediaDialog(req: DownloadPremiereMediaDialogRequest) {
  requestDialog(req, () => import('@mimir/web/components/Common/Dialogs/dialogs/DownloadPremiereMediaDialog.vue'));
}
